export default {
  allergens: null,
  languages: null
}
